import { put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { delay } from 'redux-saga';

import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';

export function* getEnvelopes(action) {
    try {
        const response = yield endpoint.get('envelopes?tagged=' + action.tagged);

        // Add key attribute to envelopes
        response.data.forEach(function(envelope) {
            envelope.key = envelope.id;
        });

        let redirectUrl = '';

        if (action.tagged === '_INBOX') {
            yield put({ type: types.SAGA_ENVELOPES_INBOX_GET.SUCCESS, payload: response.data });
            redirectUrl = '/inbox';
        } else {
            yield put({ type: types.SAGA_ENVELOPES_ARCHIVES_GET.SUCCESS, payload: response.data });
            redirectUrl = '/archives';
        }

        // Redirect to envelope if redirect is set
        if (action.customer.redirectEnvelopeId) {
            let redirectEnvelopeId = action.customer.redirectEnvelopeId;

            // Remove redirect from customer object
            delete action.customer.redirectEnvelopeId;
            yield put({ type: types.SAGA_CUSTOMER_GET.SUCCESS, payload: action.customer });

            yield put(push(redirectUrl + '/' + redirectEnvelopeId));
        }
    } catch (error) {
        if (action.tagged === '_INBOX') {
            yield put({ type: types.SAGA_ENVELOPES_INBOX_GET.FAILURE, error });
        } else {
            yield put({ type: types.SAGA_ENVELOPES_ARCHIVES_GET.FAILURE, error });
        }
    }
}



// WEBPACK FOOTER //
// ./src/sagas/envelopes.js